import httpService from "@Utils/httpService";

const baseUrl = "api/UserInvitations";

export default {
  get(params) {
    return httpService.get({
      url: baseUrl,
      params,
    });
  },
  getByCompanyId(companyId, params) {
    return httpService.get({
      url: `${baseUrl}/${companyId}`,
      params,
    });
  },
  getInvitationUrl(companyId,id) {
    return httpService.get({
      url: `${baseUrl}/${companyId}/invitation/${id}/url`,
    });
  },
  getById(id) {
    return httpService.get({
      url: `${baseUrl}/${id}`,
    });
  },
  resend(id) {
    return httpService.post({
      url: `${baseUrl}/resend/${id}`,
    });
  },
  accept(data, invitationId) {
    return httpService.put({
      url: `${baseUrl}/accept/${invitationId}`,
      data,
    });
  },
  del(id) {
    return httpService.delete({
      url: `${baseUrl}/${id}`,
    });
  },
};
